import {
	sumValues, baseUrl
} from '@/core';
import deepCopy from 'deepcopy';
import { updateTripOrdersRequest, updateTransporterOrderRequest, getTerminalsRequest } from '../requests';
import { addOrdersToTrip, addOrdersToTransporter, moveOrderToDifferentTrip, unscheduleSubOrderForEdi,  scheduleSubOrderForEdi, sendTripOnEdi } from './actions/index';
import rdbClient from 'rdb-client';

function setValue({ commit }, { value, key }) {
	commit('setValue', { value, key });
}

function setOrders({ commit }, orders) {
	commit('orderSearch/setOrders', orders);
}

function setTrips({ commit }, trips) {
	commit('tripSearch/setTrips', trips);
}

async function removeOrdersFromTrip({ state, commit, dispatch }, { orders, merge }) {
	if (!orders || !state.tripSearch.tripDetails || !state.tripSearch.tripDetails.orders) return;
	let trip = state.tripSearch.tripDetails;

	let subOrderUpdates = [];
	orders.forEach(order => {
		subOrderUpdates.push({
			removedOrderId: order.id,
			merge
		});
	});

	// Format trip to remove data not needed server-side and take clone
	let tripClone = deepCopy(trip);

	// Remove orders
	let cleanOrderList = trip.orders.filter(order => orders.findIndex( x => x.id === order.id) === -1);
	trip.volume = sumValues(cleanOrderList, 'volume');
	trip.grossWeight = sumValues(cleanOrderList, 'grossWeight');
	trip.loadingMeters = sumValues(cleanOrderList, 'loadingMeters');

	try {
		let patch = rdbClient.createPatch(tripClone, trip);
		let response = await updateTripOrdersRequest(trip.id, { tripPatches: patch, subOrderUpdates });
		commit('setTrip', response);
		dispatch('orderSearch/refreshOrders', orders.map(x => x.orderId));
		commit('setSelectedGridOrderIds', []);
		commit('setFilteredGridOrderIds', []);
	} catch (err) {
		throw new Error('failedToRemoveOrderTrip');
	}
}

async function removeOrdersFromTransporter({ state, commit, dispatch }, { orders, merge }) {
	if (!orders || !state.tripSearch.tripDetails || !state.tripSearch.tripDetails.orders) return;

	try {
		let removedIds = orders.map(({ orderId, id }) => ({ orderId, id }));
		let response = await updateTransporterOrderRequest(state.tripSearch.tripDetails.id, { removedOrders: removedIds, merge });
		commit('setTrip', response);
		dispatch('orderSearch/refreshOrders', orders.map(x => x.orderId));
		commit('setSelectedGridOrderIds', []);
		commit('setFilteredGridOrderIds', []);
	} catch (err) {
		throw new Error('failedToRemoveOrderTransporter');
	}
}

function loadSavedSearch({ commit }, savedSearch) {
	if (savedSearch) {
		commit('loadSavedSearch', savedSearch);
		commit('orderSearch/loadSavedSearch', { ...savedSearch.orderSearch, label:savedSearch.label, id:savedSearch.id });
		commit('tripSearch/loadSavedSearch', { ...savedSearch.tripSearch, label:savedSearch.label, id:savedSearch.id });
	}
}

function fetchOrders({ dispatch, commit }) {
	dispatch('orderSearch/fetchOrders');
	commit('setSelectedGridOrderIds', []);
	commit('setFilteredGridOrderIds', []);
}
function fetchTrips({ dispatch }) {
	dispatch('tripSearch/fetchTrips');
}

function fetchOrdersAndTrips({ dispatch, commit }) {
	dispatch('orderSearch/fetchOrders');
	dispatch('tripSearch/fetchTrips');
	commit('setSelectedGridOrderIds', []);
	commit('setFilteredGridOrderIds', []);
}

async function loadTripView({ commit, dispatch }, id) {
	await dispatch('tripSearch/loadSingleTrip', id);
	dispatch('tripSearch/setTripDetails', id);
	commit('setValue', { key: 'tripDetailsVisible', value: true });
}

function setTripDetails({ dispatch }, id) {
	dispatch('tripSearch/setTripDetails', id);
}

function setMapState({ commit }, { value, key }) {
	commit('setMapState', { value, key });
}

async function getTerminals() {
	let terminals = await getTerminalsRequest();
	return terminals;
}

async function updateLoadingSequence({ state, commit }, newSequence) {
	if (!newSequence || !state.tripSearch.tripDetails || !state.tripSearch.tripDetails.orders) return;

	let trip = state.tripSearch.tripDetails;

	let original = { orders: [] };
	let newSeq = { orders: [] };

	trip.orders.forEach(order => {

		original.orders.push(order);

		let newOrderData = deepCopy(order);
		newOrderData.loadingSeqNo = newSequence[order.id];

		newSeq.orders.push(newOrderData);
	});

	let patch = rdbClient.createPatch(original, newSeq);

	try {
		let response = await updateTripOrdersRequest(trip.id, { tripPatches: patch });
		commit('setTripOrders', { id: trip.id, orders: response.orders });
	} catch (err) {
		throw new Error('failedToChangeLoadingSequence');
	}
}

function getWaybill(_, orderIds) {
	let base = baseUrl();

	if (Array.isArray(orderIds) && orderIds.length > 1) {
		let form = document.createElement('form');
		form.target = '_blank';
		form.method = 'post';
		form.action = `${base}/documents/wayBill/merged`;
		form.style.display = 'none';

		let input = document.createElement('input');
		input.type = 'text';
		input.required = 'required';
		input.name = 'ids';
		input.value = orderIds;
		form.appendChild(input);
		document.body.appendChild(form);
		form.submit();
		document.body.removeChild(form);
	} else {
		let url = `${base}/documents/wayBill/${orderIds}`;
		window.open(url);
	}
}

function getPackageLabel(_, orderIds) {
	let base = baseUrl();
	let locale = localStorage.getItem('locale');

	if (Array.isArray(orderIds) && orderIds.length > 1) {
		let form = document.createElement('form');
		form.target = '_blank';
		form.method = 'post';
		form.action = `${base}/documents/packageLabel/${locale}/merged`;
		form.style.display = 'none';

		let input = document.createElement('input');
		input.type = 'text';
		input.required = 'required';
		input.name = 'ids';
		input.value = orderIds;
		form.appendChild(input);

		document.body.appendChild(form);
		form.submit();
		document.body.removeChild(form);
	} else {
		let url = `${base}/documents/packageLabel/${locale}/${orderIds}`;
		window.open(url);
	}
}

function getTransportInstruction(_, idsObjArr) {
	let baseURL = baseUrl();
	if (Array.isArray(idsObjArr) && idsObjArr.length > 1) {
		throw new Error('Not implemented! Only one transportInstruction can be retrieved at once for now.');
	} else {
		let [idsObj] = idsObjArr;
		let url = `${baseURL}/documents/transportInstruction/${idsObj.orderId}/${idsObj.subOrderId}`;
		window.open(url);
	}
}

function setMapTripDetailsVisible({ commit }, value) {
	commit('setValue', { key: 'tripDetailsVisible', value });
}

async function setSelectedGridOrderIds({ state, commit, dispatch }, ids) {
	if (state.mapSelecting) return;
	commit('setSelectedGridOrderIds', ids);
	dispatch('orderSearch/setSelectedOriginalOrderBySubOrderId', ids);
}

function setFilteredGridOrderIds({ state, commit }, ids) {
	if (state.mapSelecting) return;
	commit('setFilteredGridOrderIds', ids);
}

function ordersInMap({ commit }, orderIds) {
	commit('ordersInMap', orderIds);
}

function setSelectedMapOrderIds({ state, commit, dispatch }, ids) {
	if (state.gridSelecting) return;
	commit('setSelectedMapOrderIds', ids);
	dispatch('orderSearch/setSelectedOriginalOrderBySubOrderId', ids);
}

export default {
	addOrdersToTrip,
	addOrdersToTransporter,
	moveOrderToDifferentTrip,
	setValue,
	setOrders,
	setTrips,
	removeOrdersFromTrip,
	removeOrdersFromTransporter,
	loadSavedSearch,
	fetchOrders,
	fetchTrips,
	fetchOrdersAndTrips,
	loadTripView,
	setTripDetails,
	setMapState,
	getTerminals,
	updateLoadingSequence,
	unscheduleSubOrderForEdi,
	scheduleSubOrderForEdi,
	getWaybill,
	getPackageLabel,
	getTransportInstruction,
	sendTripOnEdi,
	setMapTripDetailsVisible,
	setSelectedGridOrderIds,
	setFilteredGridOrderIds,
	ordersInMap,
	setSelectedMapOrderIds,
};
